import { render, staticRenderFns } from "./NavArrow.vue?vue&type=template&id=e654ed3a&"
import script from "./NavArrow.vue?vue&type=script&lang=js&"
export * from "./NavArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports